module.exports = __webpack_public_path__ + "static/media/WUDS card.250aab0e.png";